export default __webpack_public_path__ + "static/media/card2.c05332c2.jpg";